import { PaddingMarginGridCombinedProps } from './types';

const usePresenter = (props: PaddingMarginGridCombinedProps): PaddingMarginGridCombinedProps => {
  return props;
};

export default usePresenter;
